import * as R from 'remeda'

import { exists } from './exists'

/**
 * 配列内の存在する値のみをフィルタリングします。
 * よく似た挙動のcompact関数があるが、そちらはtruthyな値だけがフィルタリングされる。
 *
 * @template T - 配列内の値の型。
 * @param items - フィルタリング対象の配列。
 * @returns 存在する値のみを含む配列。
 */
export function filterExists<T>(
  items: (T | null | undefined)[] | null | undefined,
): T[] {
  return R.pipe(items ?? [], R.filter(exists))
}
